import React, { useEffect, useState } from 'react';
import styles from './BotoneraDesplegable.module.css';

const BotoneraDesplegable = (props) => {
  const lista = props.lista;
  const renderBody = props.renderBody;
  const desplegarPrimero = props.desplegarPrimero;
  const estiloPlano = props.estiloPlano || false;
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    if (desplegarPrimero) {
      setOpenIndex(0);
    }
  }, [desplegarPrimero]);

  const handleToggle = (index) => {
    setOpenIndex((previous) => (previous === index ? null : index));
  };

  return (
    <div className={styles.container}>
      {lista.map((item, index) => (
        <div key={item.id} className={styles.item}>
          <button
            className={`${styles.button} ${estiloPlano ? styles.buttonPlano : ''}`}
            onClick={() => handleToggle(index)}
            aria-expanded={openIndex === index}
            aria-controls={`botonera-desplegable-panel-${index}`}
            type="button"
          >
            <span className={styles.textoButton}>
              {item.descripcion ? item.descripcion : item.nombre}
            </span>
            <span className={styles.indicador} aria-hidden="true">
              {openIndex === index ? '▲' : '▼'}
            </span>
          </button>
          {openIndex === index && (
            <div id={`botonera-desplegable-panel-${index}`} className={styles.dropdown}>
              {renderBody(item)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default BotoneraDesplegable;
